import { makeStyles } from "@material-ui/core";
import { Collection } from "@type-r/models";
import { CollapsableSection, Column, Columns, div, Flex, TilesList } from "lqx-react";
import * as React from "react";
import { useMemo } from "react";
import { PolicyBuyerSchedule } from "../../../api/policy";

const useBuyers = (buyers: Collection<PolicyBuyerSchedule>, filter) => {
    return useMemo(() => buyers.filter(filter), [ buyers[ '_changeToken' ] ]);
}

export const PolicyBuyersList = ({ buyers, $selected }: { buyers: Collection<PolicyBuyerSchedule>, $selected?}) => {
    const validBuyers = useBuyers(buyers, buyer => buyer.validateBuyer());
    const requiringReviewBuyers = useBuyers(buyers, buyer => !buyer.validateBuyer());

    return (
        <>
            <BuyersSection title={ validBuyers.length + " were successfully loaded" } buyers={ validBuyers } $selected={ $selected } notExpanded={ true } />
            <BuyersSection title={ requiringReviewBuyers.length + " Require Review" } buyers={ requiringReviewBuyers } $selected={ $selected } />
        </>
    );
};


const BuyersSection = ({ title, buyers, notExpanded, $selected }: { title: string, buyers: PolicyBuyerSchedule[], notExpanded?: boolean, $selected?}) => {
    return (
        <BuyersCollapsableSection>
            <CollapsableSection title={ title } notExpanded={ notExpanded }>
                <TilesList
                    height={ 150 }
                    items={ buyers }
                    itemSize={ 30 }
                    selected={ undefined }
                    renderer={ BuyersTile($selected) } />
            </CollapsableSection>
        </BuyersCollapsableSection>
    );
};

const BuyersCollapsableSection = div({
    '& .MuiAccordionSummary-content span': {
        textTransform: 'lowercase'
    }

});

export const BuyersTile = $selected => (({ data, index, style }) => {
    const buyer: PolicyBuyerSchedule = data.items[ index ];
    const classes = usebuyerTileClasses({ isSelected: $selected.value && $selected.value.buyerName === buyer.buyerName });

    const onBuyerClicked = buyer => $selected.set(buyer);

    return (
        <div key={ buyer.id } style={ style } className={ classes.root } onClick={ () => onBuyerClicked(buyer) }>
            <Flex row>
                <Columns>
                    <Column>
                        <BuyerTileHeaderField> { buyer.buyerName }</BuyerTileHeaderField>
                    </Column>
                </Columns>
            </Flex>
        </div>
    )
})

const usebuyerTileClasses = makeStyles({
    root: {
        backgroundColor: '#f5f7f9',
        border: '1px solid',
        borderColor: (props: any) => props.isSelected ? '#4197d6' : 'white',
        borderRadius: '5px'
    }
});

const BuyerTileHeaderField = div({
    paddingBottom: '5px',
    paddingTop: '5px',
    display: 'flex',
    fontFamily: 'Montserrat',
    fontSize: 12,
    marginRight: '1em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});